import Tween from "tween.ts"
import Animation from "../../../../src/animation/Animation";
import { Coord } from "../../../../src/types/Interface";
import Angle from "../../../../src/entities/Angle/Angle";

export default class MoveAngle extends Animation {
  constructor(Angle: Angle, endCoord: Coord, startRadian: number, endRadian: number, onUpdate: (angle, details: { coord: Coord, startRadian: number, endRadian: number }) => void, onComp: () => void) {
    super();

    const values = {
      x: Angle.x,
      y: Angle.y,
      startRadian: Angle.startRadian,
      endRadian: Angle.endRadian,
    };
    new Tween.Tween({ ...values })
      .to({
        x: endCoord.x,
        y: endCoord.y,
        startRadian,
        endRadian,
      }, 2000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(v => {
        onUpdate(Angle, { coord: { x: v.x, y: v.y }, startRadian: v.startRadian, endRadian: v.endRadian });
      })
      .onComplete(() => onComp())
      .start();
  }
}